import Network from '../network.js'

export default {
  list() {
    return Network.get('/popup-states', null, true)
  },

  getByKey({ popupKey }) {
    return Network.get(`/popup-states/${encodeURIComponent(popupKey)}`, null, true)
  },

  create({ popupKey }) {
    return Network.post('/popup-states', { popupKey }, true)
  }
}
